module.exports = __webpack_public_path__ + "files/11474e893a51f08ecb963675ef2c62f8.png";